/* CUSTOM — let a top-level nav item with a submenu also be a link.

   Dawn renders any parent menu item as a <summary>, so the URL set against it in
   Navigation is never rendered and clicking "Shop" only opened the mega panel.
   The URL is now carried on the summary as data-mg-nav-href.

   Only a mouse click navigates. Keyboard and touch keep the native disclosure
   behaviour, and deliberately so:

   - A keyboard user presses Enter on a <summary> to open it. Navigating instead
     would make the panel unreachable without a pointer.
   - A touch user has no hover, so their first tap is the only way to open the
     panel. Navigating on it would put the submenu out of reach entirely.

   Both still reach the destination through the panel's own "Shop All" row. */

(() => {
  'use strict';

  if (window.mgNavLinkInitialised) return;
  window.mgNavLinkInitialised = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('summary[data-mg-nav-href]').forEach((summary) => {
    summary.addEventListener('click', (event) => {
      // detail is 0 when the click came from Enter or Space on the summary
      // rather than from a pointer.
      if (event.detail === 0 || !canHover.matches) return;

      // Let a modified click do what the browser would do with a real link.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

      event.preventDefault();
      window.location.href = summary.dataset.mgNavHref;
    });
  });
})();
